module.exports = __webpack_public_path__ + "img/people-faces.6c05c016.png";